"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiPost = exports.api = void 0;
var app_1 = require("app");
var axios_1 = __importDefault(require("axios"));
var api = function (apiUrl, params) {
    return (0, axios_1.default)({
        method: "get",
        responseType: "json",
        url: apiUrl + app_1.UrlService.GetStringFromUrlObj(params)
    });
};
exports.api = api;
var apiPost = function (apiUrl, params) {
    return (0, axios_1.default)({
        data: params,
        method: "post",
        url: apiUrl
    });
};
exports.apiPost = apiPost;
